import React from 'react';
import { Section, Panel, DataTable, Badge, RelativeTime, StatRow } from './shared';
import { formatCount } from '../utils';

const STATUS_TONES = { open: 'blue', expired: 'amber', ended: 'grey' };

const columns = [
  { key: 'started_at', label: 'Started', render: row => <RelativeTime value={row.started_at} /> },
  { key: 'superadmin', label: 'Superadmin', render: row => <><div style={{ fontWeight: 600 }}>{row.superadmin || '-'}</div>{row.superadmin_email ? <div style={{ fontSize: '.72rem', color: 'var(--dm-muted, #647184)' }}>{row.superadmin_email}</div> : null}</> },
  { key: 'user', label: 'User', render: row => <><div style={{ fontWeight: 600 }}>{row.user || '-'}</div>{row.user_email ? <div style={{ fontSize: '.72rem', color: 'var(--dm-muted, #647184)' }}>{row.user_email}</div> : null}</> },
  { key: 'user_role', label: 'Role' },
  { key: 'reason', label: 'Reason', render: row => <span style={{ overflowWrap: 'anywhere' }}>{row.reason || '-'}</span> },
  { key: 'status_label', label: 'Status', render: row => <Badge tone={STATUS_TONES[row.status] || 'grey'}>{row.status_label}</Badge> },
  { key: 'minutes', label: 'Minutes', align: 'right', render: row => formatCount(row.minutes) },
];

/** `impersonation` section: sign-in-as-user sessions. */
const Impersonation = ({ data = {} }) => {
  const totals = data.totals || {};
  const period = totals.period_label ? ` (${totals.period_label})` : '';
  const stats = [
    { key: 'open_now', label: 'open now', value: totals.open_now, tone: Number(totals.open_now) > 0 ? 'blue' : undefined },
    { key: 'sessions', label: `sessions${period}`, value: totals.sessions_in_period },
    { key: 'superadmins', label: `superadmins${period}`, value: totals.superadmins_in_period },
    { key: 'users', label: `users signed in as${period}`, value: totals.users_in_period },
    { key: 'failed_starts', label: `failed starts${period}`, value: totals.failed_starts_in_period },
    { key: 'blocked_actions', label: `blocked actions${period}`, value: totals.blocked_actions_in_period, tone: Number(totals.blocked_actions_in_period) > 0 ? 'amber' : undefined },
  ];
  return (
    <Section id="impersonation" title="Sign in as user" subtitle={data.description} exportKey="impersonation">
      <Panel>
        <div style={{ marginBottom: 16 }}><StatRow items={stats} /></div>
        <DataTable ariaLabel="Recent sign-in-as-user sessions" columns={columns} rows={data.recent || []} getRowKey={row => row.session_id} emptyText={data.description} />
      </Panel>
    </Section>
  );
};

export default Impersonation;
